import { ReactNode } from "react";
import { Box, BoxProps } from "../Box/Box";
import styles from "./Container.module.css";

interface Props {
  width?: BoxProps["maxWidth"];
  flex?: boolean;
  children: ReactNode;
}

export function Container(props: Props): React.ReactElement {
  const { width = "medium", flex, children } = props;

  const className = [styles.marginAuto, flex ? styles.flex : ""].join(" ");

  return (
    <Box width="full" maxWidth={width} className={className}>
      {children}
    </Box>
  );
}
